jQuery(document).ready(function($){
  const swiperOption = new Swiper('.membership-slider', {
    slidesPerView: 'auto',
    spaceBetween: 17,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
    990: {
        spaceBetween: 22,
        slidesPerView: 'auto',
        centeredSlides: false,
    },
    }
  })
})